// extracted by mini-css-extract-plugin
module.exports = {"sms-code__counter":"sms-code_sms-code__counter__O_1r8"};